import { Component, OnInit , ElementRef, ViewChild, Renderer2,  Input, Output, EventEmitter} from '@angular/core';
import { Observable, of } from 'rxjs';

import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-add-option-dropdown',
  templateUrl: './add-option-dropdown.component.html',
  styleUrls: ['./add-option-dropdown.component.scss']
})
export class AddOptionDropdownComponent implements OnInit {
  @ViewChild('myInput') divElement: ElementRef;
  @ViewChild('dropdown') dropdownElement: ElementRef;
  @Input() selectedItem: any;
  @Input() data: DropdownItem[];
  @Output() onChange = new EventEmitter;
  title = 'tollupdate';
  open = false;
  openPopup = false;
  selectedValue = "Select";
  slectecControl = new FormControl();
  searchControl = new FormControl("Search");
  newCostCenterName = new FormControl("");
  filteredOptions: Observable<DropdownItem[]>;
  optionsLength = 0;
  inputFocused = false;
  costCentedAddedToas = false;
  constructor(private renderer: Renderer2, private commonService: CommonService) {
    this.searchControl.valueChanges.pipe( debounceTime(300),
    distinctUntilChanged(),
    switchMap(value => this.getFilteredOptions(value))).subscribe((data) => {
      this.filteredOptions = of(data);
    });
  }



  ngOnInit() {
    this.filteredOptions = of(this.data);
    this.slectecControl.disable();
    this.selectedValue = this.selectedItem.label;
    this.optionsLength = this.data.length;
  }
  ngAfterViewInit() {
    this.setPosition();
  }

  setPosition() {
    const rect = this.divElement.nativeElement.getBoundingClientRect();
    const yPosition = rect.bottom;
    this.renderer.setStyle(this.dropdownElement.nativeElement, 'position', 'absolute');
    this.renderer.setStyle(this.dropdownElement.nativeElement, 'top', `${yPosition - 50}px`);
  }

  getFilteredOptions(value: string): Observable<any[]> {
    if (!value.length){
      this.optionsLength = this.data.length;
      return of(this.data);
    }
    const filteredOptions = this.data.filter(option => option.label.toLowerCase().includes(value.toLowerCase()));
    this.optionsLength = filteredOptions.length;
    return of(filteredOptions);
  }




  optionClicked(val: DropdownItem){
    this.selectedValue = val.label;
    this.toggleDropDown();
    this.onChange.emit(val);
  }

  addOption()
  {

    this.openPopup = true;
  }

  toggleDropDown(){
    this.open = !this.open;
    this.inputFocused = false;
    this.searchControl.setValue('');
  }

  submitCostCenter()
  {
    this.searchControl.setValue("");
    this.commonService.addCostCenter({name: this.newCostCenterName.value, description: ''}).subscribe((res) => {
    const data = this.commonService.costcenter.value;
    data.push({guid: String(res.guid), name: res.name});
    this.commonService.costcenter.next(data);
    this.filteredOptions = of(this.data);
    this.selectedValue = this.newCostCenterName.value;
    this.onChange.emit({value: res.name, label: res.name});
    this.openPopup = false;
    this.toggleDropDown();
    this.toggleToast();
  });

  }
  toggleToast()
  {
    this.costCentedAddedToas = !this.costCentedAddedToas;
  }

  focus(){
    this.inputFocused = !this.inputFocused;
    this.searchControl.setValue('');
  }
  focusr(){
    this.inputFocused = !this.inputFocused;
    this.searchControl.setValue('');
  }
  clear()
  {
    this.newCostCenterName.setValue("");

  }

}
